import React from 'react';
import './ItemListMenu.css';

const ItemListMenu = ({ children }) => (
  <menu className="itemListMenu" type="context">
    {children}
  </menu>
);

ItemListMenu.propTypes = {};

ItemListMenu.defaultProps = {};

export default ItemListMenu;
